import { Navigate } from 'react-router-dom'
import { usePermissions } from '@/lib/auth/usePermissions'

interface PermissionRouteProps {
    permission: string
    redirectTo?: string
    children: React.ReactNode
}

/**
 * Wraps a route and redirects to `redirectTo` if the current user
 * lacks the required permission. Works alongside ProtectedRoute —
 * ProtectedRoute handles auth, PermissionRoute handles authorization.
 */
export default function PermissionRoute({
                                            permission,
                                            redirectTo = '/settings/profile',
                                            children,
                                        }: PermissionRouteProps) {
    const { hasPermission } = usePermissions()

    if (!hasPermission(permission)) {
        return <Navigate to={redirectTo} replace />
    }

    return <>{children}</>
}